module.exports = __webpack_public_path__ + "img/QR-1580x780.2a3c3087.png";